module.exports = __webpack_public_path__ + "img/20200417141858490.b942021b.png";